import { type FC } from 'react';
import cx from 'classnames';

// @ts-expect-error - TruncatedTypography doesn't have TypeScript definitions
import { TruncatedTypography } from 'src/components/TruncatedTypography';

import { type FreestyleTool } from '../../types';
import { BadgeTrending } from '../BadgeTrending';

import styles from './styles.module.css';

interface Props {
  className?: string;
  freestyleTool: Pick<FreestyleTool, 'name' | 'special'>;
}

export const FreestyleToolLabel: FC<Props> = ({ className, freestyleTool }) => (
  <div className={cx(styles.root, className)}>
    <TruncatedTypography className={styles.title}>{freestyleTool.name}</TruncatedTypography>
    {freestyleTool.special && <BadgeTrending className={styles.badge} />}
  </div>
);
